// Copyright 2017-2023 @polkadot/react-identicon authors & contributors
// SPDX-License-Identifier: Apache-2.0

import makeBlockie from 'ethereum-blockies-base64';
import React, { useMemo } from 'react';
import styledComponents from 'styled-components';

// In styled-components v6, there is a named export which can be used
// directly, i.e. "import { styled } from ..." with no more magic. Until
// such time the cjs vs esm import here is problematic, so we hack around
// the various shapes below
import { jsx as _jsx } from "react/jsx-runtime";
const styled = styledComponents.styled || styledComponents.default || styledComponents;
function Identicon({
  address,
  className = '',
  size,
  style
}) {
  const imgSrc = useMemo(() => makeBlockie(address), [address]);
  return /*#__PURE__*/_jsx(StyledImg, {
    className: className,
    size: size,
    src: imgSrc,
    style: style
  });
}
const StyledImg = styled.img(({
  size
}) => `
  display: block;
  height: ${size}px;
  width: ${size}px;
`);
export const Ethereum = /*#__PURE__*/React.memo(Identicon);